export default __webpack_public_path__ + "static/media/Mammino.0064318a.png";